import { FieldValues, UseFormRegister } from "react-hook-form";
import type { FullAddress, IDynamicFieldProps, IErrors } from "./types";
import { CustomField } from "./CustomField";
import { Grid } from "@mui/material";
import { AcctionButtons } from "../CompletionPage/AcctionButtons";
import { useAppSelector } from "../../redux";
import { selectText } from "../LanguageSelect/LanguageSelectSlice";

interface IAddressFieldsManual {
  fullAddress: FullAddress | null;
  address_fields: IDynamicFieldProps[];
  errors: IErrors;
  register: UseFormRegister<FieldValues>;
  handleClose(): void;
}

export function AddreesFieldsManual(props: IAddressFieldsManual) {
  const { address_fields, errors, register, handleClose } = props;
  const text = useAppSelector(selectText);
  return (
    <Grid container spacing={2}>
      {address_fields.map((feild, i) => {
        const key: string = feild.name;
        return (
          <CustomField
            {...register(key)}
            key={i}
            feild={feild}
            error={errors[`${feild.name}`]?.err}
            err_msg={errors[`${feild.name}`]?.msg}
          />
        );
      })}
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <Grid container>
          <AcctionButtons handleClose={handleClose} action={() => {}} type="submit" title={text.update} />
        </Grid>
      </Grid>
    </Grid>
  );
}
